import React from 'react';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { useTheme } from '../context/context';

const BasicCard = ({ title, imgsrc, description }) => {
  const { fontSize } = useTheme();

  return (
    <Card sx={{    }}>
      <div sx={{ display: 'flex', marginBottom:"5px" }}>
        <div style={{ flex: '0 0 40%' }}>
          <CardMedia
            component="img"
            // height="140"
            image={imgsrc}
            alt="Card"
            sx={{  objectFit: 'contain', maxHeight:"130px" }}
          />
        </div>
        <CardContent style={{ flex: '1 1 60%' }}>
          <Typography gutterBottom variant="h7" component="div" style={{ fontSize: `${fontSize-0.1 }rem`, fontWeight:"bold" }}>
            {title}
          </Typography>
          <Typography variant="body2" color="gray" style={{ fontSize: `${fontSize-0.3}rem` }}>
            {description}
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
};

export default BasicCard;
